import React from "react";
import { Box, Text, Grid, GridItem, Checkbox, Flex, useMediaQuery } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import "./styles.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
	RenderTextField,
	DarkButton,
	yupEmail,
	yupPassword,
	AppDispatch,
	setPageLoading,
	loginProcure,
	history,
	get_doc,
	USERID_FETCH_SUCCESS,
} from "@karkhanaui/react";
import { Mixpanel } from "../../Mixpanel.js";
const Login: React.FC<any> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const [rememberMe, setRememberMe] = React.useState<boolean>(false);
	const [authState] = useSelector((state: any) => [state.auth]);
	const [isMobileTablet] = useMediaQuery("(max-width: 768px)");

	const basicValidation = Yup.object().shape({
		userName: yupEmail,
		password: yupPassword,
	});

	const onSubmit = async (event: any) => {
		dispatch(
			setPageLoading({
				loading: true,
				loadingText: "Logging you in...",
			})
		);
		try {
			let result: any = await dispatch(
				loginProcure(event.userName, event.password)
			);
			if (result.status === 200) {
				localStorage.setItem("user_email", event.userName);
				dispatch(
					setPageLoading({
						loading: false,
						loadingText: "",
					})
				);
			}
			navigate("/home");
			const uniqueUserId: any = await get_doc({
				doc: "User ID",
				fields: ["id"],
				filters: [["name", "=", event.userName]],
			});
			console.log("unique", uniqueUserId?.data.data[0]?.id )
			if (uniqueUserId?.status === 200) {
				dispatch({
					type: USERID_FETCH_SUCCESS,
					payload: { uniqueUserId: uniqueUserId?.data.data[0]?.id },
				});
				window.dataLayer.push({
					event: "User Login",
					user_id: uniqueUserId?.data.data[0]?.id,
					user_email: event.userName,
					page_url: window.location.href,
					page_name: window.location.pathname,
					success: true,
				});
				Mixpanel.identify(authState?.uniqueUserId);
				Mixpanel.track("logged In", {
					user_id: uniqueUserId?.data.data[0]?.id,
					user_email: event.userName,
				});
			}
			navigate("/home");
			return; // Exit the function after successful login and navigation
		} catch (error) {
			Mixpanel.track("Unsuccessful login");
			window.dataLayer.push({
				event: "User Login",
				user_email: event.userName,
				page_url: window.location.href,
				page_name: window.location.pathname,
				success: false,
			});
		}

		dispatch(
			setPageLoading({
				loading: false,
				loadingText: "",
			})
		);

		history.push("/home");
	};

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			flexDirection="column"
			h="100%"
			bg={{base: "#0087ee", lg: "#fff"}}
		>
				<Box display="flex" flexDir="column" h={{base:"100%", lg: "auto"}} w={{base:"100%", lg: "auto"}} mt={{base:"2rem", lg:"0"}}>
				<Flex mb="1.5rem" flexDirection="column" justifyContent="center" px={{base: "1rem", lg: 0}}>
					<Text
						textStyle="primary.poster"
						color={!isMobileTablet ? "#000" : "#fff"}
					>
						Login
					</Text>
						<Text textStyle="primary.text" color={!isMobileTablet ? "#000" : "#fff"}>Welcome back!</Text>
				</Flex>
				
				<Box borderRadius={{base: "1rem 1rem 0 0", lg: "none"}} bg="#fff" flexGrow={1} pt={{base:"2rem", lg:"0"}}>
				<Formik
					initialValues={{ userName: "", password: "", remember: false }}
					validationSchema={basicValidation}
					onSubmit={onSubmit}
				>
					{(formik) => {
						return (
							<Form id="signinbuyer" className="buyersignin">
								<Grid templateColumns={{ xs: "repeat(1,1fr)" }} gap={5}>
									<GridItem px={{base: "0.5rem", lg: 0}}>
										<RenderTextField
											label="Email"
											name="userName"
											type="email"
											placeholder="name@company.com"
											isMandatory={true}
											_invalid={{ borderColor: "#0087ee" }}
										/>
									</GridItem>
									<GridItem px={{base: "0.5rem", lg: 0}}>
										<RenderTextField
											label="Password"
											name="password"
											type="password"
											placeholder="********"
											isMandatory={true}
											_invalid={{ borderColor: "#0087ee" }}
										/>
										<Flex justifyContent="space-between" mt={{base: 6, lg: 1}}>
											<Text
												_hover={{ textDecoration: "underline" }}
												textStyle="primary.secondaryText"
												as={Link}
												to="/forgotPassword"
											>
												Forgot password?
											</Text>
										</Flex>
									</GridItem>
									<GridItem>
										<Box
											display="flex"
											justifyContent="center"
											alignItems="center"
										>
											<Checkbox
												isChecked={rememberMe}
												onChange={() =>
													setRememberMe((prevState) => !rememberMe)
												}
											>
												<Text textStyle="primary.secondaryText">
													Remember me
												</Text>
											</Checkbox>
										</Box>
									</GridItem>
									<GridItem
										display="flex"
										justifyContent="center"
										alignItems="center"
										mt={{base: "2rem",lg:"3.375rem"}}
										px={{base: "2rem", lg: 0}}
									>
										<DarkButton
											type="submit"
											id="signinbuyerbtn"
											className="buyersigninbtn"
											width={isMobileTablet?"100%": "23.75rem"}
											
											height="50px"
											children="Log In"
											bg="#0087ee"
											_hover={{ backgroundColor: "#0066B4" }}
										/>
									</GridItem>
									<GridItem
										display="flex"
										alignItems="center"
										justifyContent="center"
									>
										<Box display="flex">
											<Text textStyle="primary.secondaryText" mt="1em">
												Don't have an account?
												<span>
													<Text
														textStyle="primary.link"
														sx={{ fontWeight: "600" }}
														as={Link}
														to="/register"
													>
														&nbsp;Sign Up
													</Text>
												</span>
											</Text>
										</Box>
									</GridItem>
								</Grid>
							</Form>
						);
					}}
				</Formik>
				</Box>
			</Box>
		</Box>
	);
};

export default Login;
